<template>
    <ul class="list">
        <li class="item" v-if="mold == 'article'" v-for="item in items" :key="item.id">
            <router-link :to='{name:"detailView",params:{detail_type:"mobile",cid:item.category_id,id:item.id}}' class="box">	
                <div class="img-box">
                    <img v-lazy="resourceUrl+item.thumbnail" :alt="item.post_title">
                </div>
                <div class="text-box flex-1">
                    <h3>{{item.post_title}}</h3>
                    <div class="info">
                        <span><i class="iconfont icon-cate"></i>{{item.category_name}}</span>
                        <span><i class="iconfont icon-time"></i>{{formateTime(item.published_time)}}</span>
                        <span><i class="iconfont icon-read"></i>{{item.post_hits}}</span>
                    </div>
                </div>
            </router-link>
        </li>
        <li class="video-item" v-if="mold == 'video'" v-for="item in items" :key="item.id">
        	<h3 class="tit">{{item.post_title}}</h3>
	    	<video class="video" controls preload="none" :poster="resourceUrl + item.thumbnail" v-if="item.video_url == ''">
				<source :src="resourceUrl + item.video" type='video/mp4' />
			</video>
	    	<iframe frameborder="0" width="100%" style="height: 3.88rem;z-index: 10;" :src="item.video_url" allowfullscreen v-else></iframe>
	    	<div class="info">
	    		<span><i class="iconfont icon-cate"></i>{{item.category_name}}</span>
	    		<span><i class="iconfont icon-time"></i>{{formateTime(item.published_time)}}</span>
	    		<span><i class="iconfont icon-read"></i>{{item.post_hits}}</span>
	    	</div>
        </li>
    </ul>
</template>

<script>
import {resourceUrl} from '../common/util/config.js'
export default {
	props: {
		items: {
			type: Array,
			required: true
		},
		mold: {
			type: String,
			default: 'article'
		}
	},
    data () {
        return {
        	resourceUrl
        }
    },
    methods: {
    	formateTime (date) {
    		let time = new Date(date * 1000);
    		let fmt = 'yy-dd hh:mm'
    		if (/(y+)/.test(fmt)) {
    			let month = time.getMonth() + 1;
    			month = month < 10 ? '0' + month : month;
    			fmt = fmt.replace(RegExp.$1,month);
    		}
    		if (/(d+)/.test(fmt)) {
    			let day = time.getDate();
    			day = day < 10 ? '0' + day : day;
    			fmt = fmt.replace(RegExp.$1,day);
    		}
    		if (/(h+)/.test(fmt)) {
    			let hours = time.getHours();
    			hours = hours < 10 ? '0' + hours : hours;
    			fmt = fmt.replace(RegExp.$1,hours);
    		}
    		if (/(m+)/.test(fmt)) {
    			let minutes = time.getMinutes();
    			minutes = minutes < 10 ? '0' + minutes : minutes;
    			fmt = fmt.replace(RegExp.$1,minutes);
    		}
    		return fmt;
    	}
    }
}
</script>
<style lang="scss">
	.list{
		padding: .2rem .3rem;
		.item{
			a{
				min-height: 1.6rem;
				border-bottom: 1px solid #e6e6e6;
				padding: .2rem 0;
			}
			.img-box{
				width: 2.5rem;
			    height: 1.6rem;
			    text-align: center;
			    margin-right: .2rem;
			    overflow: hidden;
			    img{
			    	max-width: 100%;
    				max-height: 100%;
			    }
			}
			.text-box{
				h3{
					height: .92rem;
				    line-height: .46rem;
				    overflow: hidden;
				    text-overflow: ellipsis;
				    display: -webkit-box;
				    -webkit-line-clamp: 2;
				    -webkit-box-orient: vertical;
				    font-size: .28rem;
				    font-weight: 600;
				    margin-bottom: .3rem;
				}
				.info{
					font-size: .22rem;
				    color: #999;
					span{
						margin-right: .15rem;
						display: inline-block;
    					line-height: .36rem;
					}
					.iconfont{
						font-size: .36rem;
						margin-right:.08rem;
						vertical-align:middle;
					}
				}
			}
			&:last-child {
				a{
					border-bottom:none;
				}
			}
		}
		.video-item{
			border-bottom: 1px solid #e6e6e6;
			.tit{
				max-height: .8rem;
				line-height: .4rem;
				font-size: .26rem;
				color: #333;
				padding-top:.1rem;
				margin-bottom:.1rem;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
			}
			.video{
				height: 3.88rem;
				background:#f5f5f5;
				width:100%;
			}
			.info{
				padding:.18rem 0;
				font-size: .22rem;
				span{
					margin-right: .15rem;
					display: inline-block;
					line-height: .36rem;
				}
				.iconfont{
					font-size: .36rem;
					margin-right:.1rem;
					vertical-align:middle;
				}
			}
			&:last-child{
				border-bottom:none;
			}
		}
	}
	#youku-playerBox{
		height:100%!important;
		.x-video-title{display: none!important;}
	}
</style>


// WEBPACK FOOTER //
// src/components/List.vue